module.exports = __webpack_public_path__ + "img/consentManagement2.d6f2bc53.svg";